import React from "react";
import { Flex } from "@chakra-ui/react";
import { FaLinkedinIn, FaGithub, FaBehance } from "react-icons/fa";
import { SiPolywork } from "react-icons/si";

const SocialMediaIcons = () => {
  return (
    <Flex justifyContent={"center"} alignItems={"center"} gap={5}>
    <a href="https://www.linkedin.com/in/mary-ojo/" target="_blank">
    <FaLinkedinIn />
    </a>
      {/* <SiPolywork /> */}
      <a href="https://www.behance.net/maryojo" target="_blank">
      <FaBehance />
      </a>
      <a href="https://github.com/maryojo" target="_blank"> 
      <FaGithub />
      </a>
    </Flex>
  );
};

export default SocialMediaIcons;
